"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const NavigationWrapper = styled_components_1.default.div `
  .MuiAppBar-root {
    background-color: ${(props) => props.theme.palette ? props.theme.palette.colorAppBar.main : "#000"};
    color: ${(props) => props.theme.palette ? props.theme.palette.colorOnAppBar.main : "#000"};
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  }
`;
const Navigation = (props) => {
    const { headline, icon, onClick } = props;
    return (react_1.default.createElement(NavigationWrapper, { "data-testid": "navigation", className: "navigation" },
        react_1.default.createElement(material_1.AppBar, { position: "fixed" },
            react_1.default.createElement(material_1.Toolbar, null,
                react_1.default.createElement(material_1.IconButton, { size: "large", edge: "start", "data-testid": "back-button", className: "back-button", "aria-label": "back button", onClick: () => onClick() }, icon === "arrow_back" ? (react_1.default.createElement(ArrowBack_1.default, { color: "colorOnAppBar" })) : (react_1.default.createElement(Close_1.default, { color: "colorOnAppBar" }))),
                react_1.default.createElement(material_1.Typography, { noWrap: true, component: "div", sx: { flexGrow: 1, display: { sm: "block" } }, className: "page-title" }, headline)))));
};
exports.Navigation = Navigation;
exports.default = exports.Navigation;
